import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../AdvertisementDetails/AdvertisementDetails.css";
import emptycart from "../../assets/empty-cart.png"
import rating from "../../assets/Star.png";
import installement from "../../assets/installement.png";
import international from "../../assets/international.png";
import productrating from "../../assets/product-rating.png";
import insta from "../../assets/insta.png";
import whatsapp from "../../assets/whatsapp.png";
import facebook from "../../assets/facebook.png";
import { FaStar } from "react-icons/fa";
import placeholder from "../../assets/placeholder.jpg";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { toast } from "react-toastify";


export default function AdvertisementDetails() {
  const { id } = useParams();
  const [ad, setAd] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userRate, setUserRate] = useState(0); 
  const [rating, setRating] = useState(0);
const [loading, setLoading] = useState(true);
const navigate = useNavigate()

const [showDeleteModal, setShowDeleteModal] = useState(false);
const token = localStorage.getItem("token");
  // Fetch product by ID
useEffect(() => {
  const token = localStorage.getItem("token");

  setLoading(true);

  axios
    .get(BaseUrl + BuyerServicesUrl.GetProductById.replace("{id}", id), {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      const data = res.data?.data?.productDetails;
      setAd(data || null);
    })
    .catch((err) => {
      console.log(err);
      setAd(null);
    })
    .finally(() => {
      setLoading(false);
    });
}, [id]);


// if (loading) {
//   return (
//     <div className="text-center mt-5 pt-5">
//       <div className="spinner-border text-primary"></div>
//       <p className="mt-3">جاري تحميل الإعلان...</p>
//     </div>
//   );
// }

// if (loading) {
//   return (
//     <div className="text-center mt-5 pt-5">
//       <div className="spinner-border text-primary"></div>
//       <p className="mt-3">جاري تحميل الإعلان...</p>
//     </div>
//   );
// }

// if (!ad) {
//   return (
//     <div className="text-center mt-5 pt-5">
//       <img src={emptycart}/>
//       <h4>لا يوجد إعلان بهذا الرقم</h4>
//     </div>
//   );
// }

if (loading) {
  return (
    <div
      className="ads-loader mb-5 pb-5"
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
      }}
    >
      <div className="loader-circle mb-3"></div>
      <p className="fw-bold">جاري تحميل الإعلان...</p>
    </div>
  );
}

if (!loading && !ad) {
  return (
    <div className="ads-loader text-center mt-5 pt-5">
      <img src={emptycart} width="200" className="mb-3" alt="empty" />
      <h4 className="fw-bold">لا يوجد إعلان بهذا الرقم</h4>
    </div>
  );
}


  const images = ad.image || [];

  // Handle user rating click
  const handleRate = async (rate) => {
    setUserRate(rate); // update stars immediately
    const token = localStorage.getItem("token");

    try {
      await axios.post(
        BaseUrl+ BuyerServicesUrl.RateProduct.replace("{id}", id), // bind ID here
        { rate },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      console.error("Rating error:", err);
    }
  };

const handleAddToCart = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    toast.info("يرجى تسجيل الدخول أولاً لإضافة المنتج إلى السلة 🛒", {
      position: "bottom-right",
    });
  
    return;
  }

  try {
    await axios.post(
      BaseUrl + BuyerServicesUrl.AddToCart,
      {
        product_id: ad.id,
        quantity: 1,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("تمت إضافة المنتج إلى السلة بنجاح 🛒", {
      position: "bottom-right",
    });


  } catch (err) {
    console.log(err);

    toast.error("حدث خطأ أثناء إضافة المنتج، حاول مرة أخرى", {
      position: "bottom-right",
    });
   
  }
};
const isOutOfStock =
  ad.quantity === 0 ||
  ad.quantity === "0" ||
  ad.status === "out_of_stock" ||
  ad.status === "out of stock" ||
  ad.status === "unavailable";


  const handleDeleteAd = async () => {
    console.log("DELETE CLICKED");
  const token = localStorage.getItem("token");

  try {
    await axios.delete(
      BaseUrl +
        BuyerServicesUrl.DeleteAdvertisement.replace("{id}", id),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("تم حذف الإعلان بنجاح");

    navigate("/myadvertisements");
  } catch (err) {
    console.log(err);

    toast.error("حدث خطأ أثناء حذف الإعلان");
  }
};
  return (
    
    <div className="dproduct-page mb-5 pb-5 container c">
      {/* ===== TITLE ===== */}
      <h1 className="product-heading dproduct-heading2">
        تفاصيل الإعلان / <span className="comm">{ad.categoryName}</span>
      </h1>

      <div className="product-wrapper col-md-6">
        {/* ===== IMAGE ===== */}
        <div className="dproduct-image-box col-md-6">
          {images.length > 0 ? (
        <img
  src={
    images.length > 0
      ? images[currentIndex]?.url
      : placeholder
  }
  alt={ad.name}
  className="main-image2"
  onError={(e) => {
    e.target.src = placeholder;
  }}
/>

          ) : (
            <div className="main-image2 d-flex align-items-center justify-content-center">
              لا توجد صورة
            </div>
          )}
        </div>

        {/* ===== INFO ===== */}
        <div className="product-info ">
          <div className="dtitle-rating-row">
            <h2 className="dproduct-title">{ad.name}</h2>
            <div className="drating-row">
              {/* <img src={rating} alt="star" /> */}
              {/* <span className="drate-number">{ad.avg_rate?.toFixed(1) || 0}</span> */}
            </div>
          </div>
        
          <div className="row">

        <div className="col-md-6">
          <p className="product-desc2">{ad.description?.split(" ").slice(0, 3).join(" ")}...
       
        </p>

          </div>
   <div className="col-md-6">
    {/* <img src={rating} alt="star" /> */}
         <span className="drate-number">{ad.avg_rate?.toFixed(1) || 0}</span>
    <i className="fa fa-star staricon p-2" ></i>
     
          </div>
          </div>
          <div className="dprice-row">
            <span className="dcurrent-price">
              {ad.priceAfterDiscount} {ad.currency_type}
            </span>
            <span className="dold-price">
              {ad.price} {ad.currency_type}
            </span>
            <span className="ddiscount">{ad.discount}%</span>
          </div>
        </div>
      </div>

      {/* ===== SHIPPING / INSTALLMENT ===== */}
      {/* <div className="big-cart d-flex align-items-center">
        <div className="first-cart">
          <img src={international} alt="" />
          <span className="text-white d-block">
            {ad.delivery_type === "internal" ? "شحن داخلي" : "شحن دولي"}
          </span>
        </div>


        <div className="second-cart">
  <img src={installement} alt="installment" />
  <span className="text-white d-block">
    {Number(ad?.is_installment) === 1 ? "متاح تقسيط" : "لا يوجد تقسيط"}
  </span>
</div>
       
      </div> */}

  {/* <button className="edit-ad-btn" onClick={() =>(`/editad/${id}`)}> */}
    {/* <button
  className="edit-ad-btn"
  onClick={() => navigate(`/editad/${id}`)}
>
    تعديل
    <i className="fa fa-pencil"></i>
  </button>

<button
  className="delete-ad-btn"
  onClick={() =>{
  console.log("OPEN MODAL");
    setShowDeleteModal(true)}}

>   حذف
    <i className="fa fa-trash"></i>
  </button> */}
  {/* {token && (
  <div className="ads-actions">

    <button
      className="edit-ad-btn"
      onClick={() => navigate(`/editad/${id}`)}
    >
      تعديل
      <i className="fa fa-pencil"></i>
    </button>

    <button
      className="delete-ad-btn"
      onClick={() => {
        console.log("OPEN MODAL");
        setShowDeleteModal(true);
      }}
    >
      حذف
      <i className="fa fa-trash"></i>
    </button>

  </div>
)} */}
{token && (
  <div className="ads-actions">

    <button
      className="edit-ad-btn"
      onClick={() => navigate(`/editad/${id}`)}
    >
      تعديل
      <i className="fa fa-pencil"></i>
    </button>

    <button
      className="delete-ad-btn"
      onClick={() => {
        console.log("OPEN MODAL");
        setShowDeleteModal(true);
      }}
    >
      حذف
      <i className="fa fa-trash"></i>
    </button>

  </div>
)}
      {/* ===== STORE CARD ===== */}
      <div className="product-bottom-box mt-5 mb-5">
        <div className="seller-box mt-4">
          <div className="seller-info-wrap">
            {/* <img
              src={ad.store_image || "/placeholder.jpg"}
              className="seller-img"
              alt="seller"
            /> */}
            
            {/* <div className="d-flex flex-column w-100">
              <div className="seller-info mb-2">
                <h4 className="seller-name">{ad.store_name || "المتجر"}</h4>
                <div className="share-icons socialicons2">
                  {ad.linkFacebook && <img src={facebook} alt="facebook" />}
                  {ad.linkWhatsapp && <img src={whatsapp} alt="whatsapp" />}
                  {ad.linkInsta && <img src={insta} alt="instagram" />}
                </div>
              </div>
              <p className="seller-location text-end">الحالة: {ad.status}</p>
            </div> */}
          </div>
        </div>

        {/* <hr className="divider" /> */}

        {/* ===== STAR RATING ===== */}
        <h3 className="rate-title">تقييمك للمنتج</h3>
        {/* <div className="stars">
          {[1, 2, 3, 4, 5].map((i) => (
            <img
              key={i}
              src={productrating}
              style={{
                opacity: userRate >= i ? 1 : 0.3,
                cursor: "pointer",
                marginRight: 5,
              }}
              onClick={() => handleRate(i)}
              alt={`${i} stars`}
            />
          ))}
        </div> */}
        <div className="stars">
  {[1, 2, 3, 4, 5].map((star) => (
    <span
      key={star}
      onClick={() => setRating(star)}
      className={star <= rating ? "active-star" : ""}
    >
      ★
    </span>
  ))}
  
</div>
{/* ===== ADD TO CART BUTTON ===== */}


        {/* <p className="text-muted small mt-2">
          إجمالي التقييمات: {ad.total_rate || 0}
        </p> */}
      </div>
      <div className="add-to-cart-fixed">
  {/* <button
    className="add-to-cart-btn"
    onClick={handleAddToCart}
  >
    أضف للسلة
  </button> */}
<button
  className={`add-to-cart-btn ${isOutOfStock ? "cart-disabled" : ""}`}
  onClick={handleAddToCart}
  disabled={isOutOfStock}
>
  {isOutOfStock ? "غير متوفر حالياً" : "أضف للسلة"}
</button>
</div>
{showDeleteModal && (
  <div className="delete-modal-overlay">
    <div className="delete-modal-box">

      <div className="warning-icon">
        <i className="fa fa-exclamation-triangle"></i>
      </div>

      <h3>حذف</h3>

      <p>هل أنت متأكد من حذف الإعلان نهائياً؟</p>

      <div className="delete-modal-actions">

   <button onClick={handleDeleteAd} className="confirm-delete-btn">
  تأكيد الحذف
</button>


        <button
          className="cancel-delete-btn"
          onClick={() => setShowDeleteModal(false)}
        >
          إلغاء
        </button>

      </div>
    </div>
  </div>
)}
    </div>
  );
}